export default __webpack_public_path__ + "images/mx-bc63d25be57acf721e56aa378395e51b.svg";